import {ChargeCategory} from '@shipwell/backend-core-singlerequestparam-sdk';
import {useQuery} from '@tanstack/react-query';
import {CONTRACT_CHARGE_ITEMS} from '../queryKeys';
import {getContractChargeItems} from 'App/api/contracts/typed';

export const useGetContractChargeItems = ({
  shipmentId,
  contractId
}: {
  contractId?: string | null;
  shipmentId?: string;
}) => {
  const {isError, data, isFetching} = useQuery(
    [CONTRACT_CHARGE_ITEMS, contractId, shipmentId],
    async () => {
      if (!contractId) {
        throw new Error('contractId is required.');
      }
      if (!shipmentId) {
        throw new Error('shipmentId is required.');
      }

      return getContractChargeItems({
        contractId,
        calculateContractChargeItems: {shipment_id: shipmentId}
      });
    },
    {
      onError: (error) => console.error(error),
      enabled: !!contractId && !!shipmentId
    }
  );

  const {charge_items: charges} = data || {};

  const lineHaulCharge = charges?.find((charge) => charge.category === ChargeCategory.Lh);
  const fuelCharge = charges?.find((charge) => charge.category === ChargeCategory.Fsc);
  const additionalStopCharge = charges?.find((charge) => charge.category === ChargeCategory.Other);

  const total = [lineHaulCharge, fuelCharge, additionalStopCharge].reduce(
    (acc, chargeItem) => acc + (chargeItem?.amount || 0),
    0
  );

  return {isLoadingChargeItems: isFetching, isError, lineHaulCharge, fuelCharge, additionalStopCharge, total};
};
